import { ObjectDirective } from 'vue';

import { SharedEvents } from 'src/rappid/controller';

const BATCH_NAME = 'inspector-input';

const batchDirective: ObjectDirective = {

    bind(element, binding, vNode): void {
        element.addEventListener('focus', onFocus);
        element.addEventListener('focusout', onFocusOut);

        function onFocus() {
            vNode.context.$eventBusService.emit(SharedEvents.GRAPH_START_BATCH, BATCH_NAME);
        }
        function onFocusOut() {
            vNode.context.$eventBusService.emit(SharedEvents.GRAPH_STOP_BATCH, BATCH_NAME);
        }
    }
};

export default batchDirective;
